import { render } from "./SubmissionItem.vue?vue&type=template&id=1074e05c"
import script from "./SubmissionItem.vue?vue&type=script&lang=js"
export * from "./SubmissionItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/coastal-watchers-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__